const apiConfig = {
//    "baseUrlMaster":"http://localhost:8082",
   
    // "baseUrl":"https://synergy-cf-api.axodesk.com:8084",
    "baseUrl":"https://kb-synergy.axodesk.com:8080",
    //"baseUrlMaster":"https://kb-synergy.axodesk.com:8080",

 
    // "baseUrlSecurity": "https://synergy-cf-api.axodesk.com:8090",
    // "baseUrlSecurity": "http://localhost:8081",
    // "gatWayUrl":"https://79a4z7n2g5.execute-api.ap-south-1.amazonaws.com/dev", // https://79a4z7n2g5.execute-api.ap-south-1.amazonaws.com/dev/authenticate
 
 
     // "baseUrl":"https://synergy-api.coreforce.com:8081",            
    "baseUrlDocument":"https://synergy-api.coreforce.com:8083",
    "baseUrlMaster":"https://synergyserver1.coreforce.com:8082",
    "baseUrlReport": "https://synergyserver1.coreforce.com:8083",
    "baseUrlMasterProject":"https://synergyserver1.coreforce.com:8084",
    "baseUrlOthers": "https://synergyserver1.coreforce.com:8085",
    "baseUrlIssue":"https://synergyserver2.coreforce.com:8082",
    "baseUrlMasterWs":"https://synergyserver2.coreforce.com:8083",
    "baseUrlBoard":"https://synergyserver3.coreforce.com:8082",
    "baseUrlIdentity": "https://synergyserver4.coreforce.com:8083",
    "baseUrlSecurity": "https://synergyserver4.coreforce.com:8084",
    "baseUrlCache": "https://synergy-cache-api.axodesk.com:8096",
    "baseUrlTimesheet": "https://synergy-timesheet.axodesk.com:8082",
    "baseUrlAssesments":"https://synergyserver3.coreforce.com:8083",
    "baseUrlBiometic":"https://synergyserver3.coreforce.com:8089",
 
     "gatWayUrl":"https://e0olvjr9p5.execute-api.us-east-1.amazonaws.com/prod",
    // "gatWayUrl":"http://localhost:8081",
    "socketUrl":"wss://synergy-cf.axodesk.com:8097",
    "apiKey": "apiKey",
    "appId": "b0dc92bf-3710-4e11-a87d-4d72585cd281",
    "secrect": "secrect"
 
 
 
 
}
 
export default apiConfig;
